import { createContext, useContext } from "react"

// The server's wide/narrow guess for this request (see viewport-hint.ts), for
// width-switching layouts to use as their first-render value. undefined when no
// route provides one: those layouts render client-only and can measure.
const ViewportHintContext = createContext<boolean | undefined>(undefined)

export const ViewportHintProvider = ViewportHintContext.Provider

export function useViewportHint(): boolean | undefined {
  return useContext(ViewportHintContext)
}
